import { API_URL } from '../../../config';

// Petits outils partagés par les modules de TeckiA Utile (web).
export const token = () => localStorage.getItem('auth_token');

export const authFetch = (path, opts = {}) =>
  fetch(`${API_URL}${path}`, { ...opts, headers: { Authorization: `Bearer ${token()}`, ...(opts.headers || {}) } });

export const postJson = async (path, body) => {
  const r = await authFetch(path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  let data = {};
  try { data = await r.json(); } catch (_) { /* réponse non JSON */ }
  return { status: r.status, data };
};

// Envoi de fichier avec pourcentage (fetch ne sait pas le faire).
export const uploadForm = (path, formData, onPct) => new Promise((resolve) => {
  const xhr = new XMLHttpRequest();
  xhr.open('POST', `${API_URL}${path}`);
  xhr.setRequestHeader('Authorization', `Bearer ${token()}`);
  xhr.upload.onprogress = (e) => { if (e.lengthComputable && onPct) onPct(Math.round((e.loaded / e.total) * 100)); };
  xhr.onload = () => {
    let data = {};
    try { data = JSON.parse(xhr.responseText); } catch (_) { /* réponse non JSON */ }
    resolve({ status: xhr.status, data });
  };
  xhr.onerror = () => resolve({ status: 0, data: { message: 'Envoi impossible. Vérifiez votre connexion et réessayez.' } });
  xhr.send(formData);
});

// Téléchargement protégé (en-tête d'authentification) -> enregistre le fichier sur l'appareil.
export const downloadFile = async (path, fallbackName) => {
  const r = await authFetch(path);
  if (!r.ok) {
    let msg = 'Fichier indisponible ou expiré.';
    try { msg = (await r.json()).message || msg; } catch (_) { /* pas de JSON */ }
    throw new Error(msg);
  }
  const cd = r.headers.get('Content-Disposition') || '';
  const m = cd.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
  const name = m ? decodeURIComponent(m[1]) : fallbackName;
  const url = URL.createObjectURL(await r.blob());
  const a = document.createElement('a');
  a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};

export const fmtAr = (n) => `${Number(n || 0).toLocaleString('fr-FR')} Ar`;
export const fmtSize = (b) => (b >= 1048576 ? `${(b / 1048576).toFixed(1)} Mo` : `${Math.max(1, Math.round(b / 1024))} Ko`);
export const fmtDur = (s) => `${Math.floor(s / 60)}:${String(Math.round(s % 60)).padStart(2, '0')}`;

export const ACCEPT_MEDIA = 'audio/*,video/*,.mp3,.wav,.ogg,.oga,.opus,.m4a,.aac,.flac,.wma,.aiff,.amr,.mp4,.mov,.mkv,.avi,.webm,.m4v,.3gp,.wmv,.flv,.mpeg,.mpg,.ts';
